import { render } from "./TicketDownloadButton.vue?vue&type=template&id=571b406e&lang=pug"
import script from "./TicketDownloadButton.vue?vue&type=script&lang=ts"
export * from "./TicketDownloadButton.vue?vue&type=script&lang=ts"
script.render = render

export default script